__turbopack_context__.v({
  "fade-in-unwkr76": "authorisationsList-module-scss-module__GnLPzq__fade-in-unwkr76",
  "listWrapper": "authorisationsList-module-scss-module__GnLPzq__listWrapper",
  "skeleton-item": "authorisationsList-module-scss-module__GnLPzq__skeleton-item",
  "wrapper": "authorisationsList-module-scss-module__GnLPzq__wrapper",
});
